import { Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { BetaBanner } from './components/BetaBanner';
import { RequireAuth } from './components/RequireAuth';
import { AuthProvider } from './contexts/AuthContext';
import { HomePage } from './pages/Home';
import { AboutPage } from './pages/About';
import { ResidentApplication } from './pages/ResidentApply';
import { ProviderApplication } from './pages/ProviderApply';
import { VolunteerApplication } from './pages/VolunteerApply';
import { MowDaySignup } from './pages/MowDaySignup';
import { MyMowDaysPage } from './pages/MyMowDays';
import { DashboardPage } from './pages/Dashboard';
import { AdminAssignPage } from './pages/AdminAssign';
import { AdminPreviewListPage } from './pages/AdminPreviewList';
import { AdminPreviewPage } from './pages/AdminPreview';
import { LifecyclePage } from './pages/Lifecycle';
import { KeepMowingPage } from './pages/KeepMowing';
import { KeepMowingDetailPage } from './pages/KeepMowingDetail';
import { AdminContinuationsPage } from './pages/AdminContinuations';
import { AdminPhotoVettingPage } from './pages/AdminPhotoVetting';
import { HirePage } from './pages/Hire';
import { ThankYouPage } from './pages/ThankYou';
import { AdminPage } from './pages/Admin';
import { LoginPage } from './pages/Login';
import { SignupPage } from './pages/Signup';
import { NotFoundPage } from './pages/NotFound';
import { ScrollToTop } from './components/ScrollToTop';

export default function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-cream flex flex-col">
        <ScrollToTop />
        <BetaBanner />
        {/* Spacer matches BetaBanner's fixed height so page content
            sits below the banner instead of underneath it. */}
        <div className="h-10 sm:h-11 shrink-0" aria-hidden="true" />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route
              path="/apply"
              element={
                <RequireAuth>
                  <ResidentApplication />
                </RequireAuth>
              }
            />
            <Route
              path="/provider"
              element={
                <RequireAuth>
                  <ProviderApplication />
                </RequireAuth>
              }
            />
            <Route
              path="/volunteer"
              element={
                <RequireAuth>
                  <VolunteerApplication />
                </RequireAuth>
              }
            />
            <Route
              path="/mow-day"
              element={
                <RequireAuth>
                  <MowDaySignup />
                </RequireAuth>
              }
            />
            <Route
              path="/my-mow-days"
              element={
                <RequireAuth>
                  <MyMowDaysPage />
                </RequireAuth>
              }
            />
            <Route
              path="/dashboard"
              element={
                <RequireAuth>
                  <DashboardPage />
                </RequireAuth>
              }
            />
            <Route
              path="/hire"
              element={
                <RequireAuth>
                  <HirePage />
                </RequireAuth>
              }
            />
            <Route path="/thank-you/resident" element={<ThankYouPage kind="resident" />} />
            <Route path="/thank-you/provider" element={<ThankYouPage kind="provider" />} />
            <Route path="/thank-you/volunteer" element={<ThankYouPage kind="provider" />} />
            <Route path="/thank-you/hire" element={<ThankYouPage kind="hire" />} />
            <Route
              path="/admin"
              element={
                <RequireAuth adminOnly>
                  <AdminPage />
                </RequireAuth>
              }
            />
            <Route
              path="/admin/assign"
              element={
                <RequireAuth adminOnly>
                  <AdminAssignPage />
                </RequireAuth>
              }
            />
            <Route
              path="/admin/preview"
              element={
                <RequireAuth adminOnly>
                  <AdminPreviewListPage />
                </RequireAuth>
              }
            />
            <Route
              path="/admin/preview/:kind/:id"
              element={
                <RequireAuth adminOnly>
                  <AdminPreviewPage />
                </RequireAuth>
              }
            />
            <Route path="/lifecycle" element={<LifecyclePage />} />
            <Route path="/keep-mowing" element={<KeepMowingPage />} />
            <Route path="/keep-mowing/:id" element={<KeepMowingDetailPage />} />
            <Route
              path="/admin/continuations"
              element={
                <RequireAuth adminOnly>
                  <AdminContinuationsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/admin/photo-vetting/:residentId"
              element={
                <RequireAuth adminOnly>
                  <AdminPhotoVettingPage />
                </RequireAuth>
              }
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </AuthProvider>
  );
}
